import Vue from 'vue';
import VueX from 'vuex';
import createPersistedState from "vuex-persistedstate"
Vue.use(VueX);

export default new VueX.Store({
    plugins: [createPersistedState()],// 缓存state
    state: {
        token: '',                      //Token
        // toast: true,
        // toastCont: '',
        params: '',
        timeRange: {},
        pileInfo:{},
    },
    mutations: {
        setToken(state,token){
            state.token = token
        },
        setParams(state,params){
            state.params = params
        },
        setTimeRange(state,timeRange){
            state.timeRange = timeRange
        },
        setToast(state,toastCont){
            state.toastCont = toastCont
            state.toast = true
        },
        setPileInfo(state,pileInfo){
            state.pileInfo = pileInfo
        },
    },
    actions: {
       
    }
});


// WEBPACK FOOTER //
// ./src/vuex-store/index.js